import Services from './index';
import {
  CREATIVE_URL,
  CREATIVE_CAMPAIGN_URL,
  UPLOAD_ATTACHMENTS_CREATIVE_URL,
  UPLOAD_DELETE_URL,
  GET_ATTACHMENT_CREATIVE_URL,
  CREATIVE_ASSISTANT_URL,
} from 'consts/api';
import { isArray } from 'lodash';

class CreativeServices {
  createInCampaign({ userId, cpId, creativeId, status }) {
    return Services.post(CREATIVE_CAMPAIGN_URL, {
      action: 'create',
      cpId,
      creativeId,
      userId,
      status: 0,
    });
  }

  getCreativeByIdInCampaign({ id, status }) {
    return Services.post(CREATIVE_CAMPAIGN_URL, {
      action: 'read',
      id,
      status: 0,
    });
  }

  updateCreativeInCampaign({ id, status, userId }) {
    return Services.post(CREATIVE_CAMPAIGN_URL, {
      action: 'update',
      id,
      userId,
      status: status,
    });
  }

  deleteCreativeInCampaign({ id, userId }) {
    return Services.post(CREATIVE_CAMPAIGN_URL, {
      action: 'delete',
      id,
      userId,
      status: 0,
    });
  }

  getCreativeByCampaignId({ campaignId, userId }) {
    return Services.post(CREATIVE_CAMPAIGN_URL, {
      action: 'getByCampaignId',
      campaignId,
      userId,
    });
  }

  getByCreativeId({ creativeId, userId }) {
    return Services.post(CREATIVE_CAMPAIGN_URL, {
      action: 'getByCreativeId',
      creativeId,
      userId,
    });
  }

  getList(body = {}) {
    return Services.post(CREATIVE_URL, {
      action: 'getByUserId',
      ...body,
    });
  }

  getById({ id }) {
    return Services.post(CREATIVE_URL, {
      action: 'read',
      id,
    });
  }

  create(body = { title: '', message: '', routeId: '' }) {
    return Services.post(CREATIVE_URL, {
      action: 'create',
      ...body,
    });
  }

  update(body = { id: '', title: '', message: '', routeId: '' }) {
    return Services.post(CREATIVE_URL, {
      action: 'updateAndResubmit',
      ...body,
    });
  }

  delete({ id }) {
    return Services.post(CREATIVE_URL, {
      action: 'delete',
      id,
    });
  }

  uploadAttachments({ files, creativeId }) {
    const body = new FormData();

    if (isArray(files)) {
      for (let file of files) {
        body.append('files', file);
      }
    }
    body.append('creativeId', creativeId);

    return Services.post(UPLOAD_ATTACHMENTS_CREATIVE_URL, body);
  }

  deleteAttachment({ attachmentId }) {
    const body = new FormData();
    body.append('attachmentId', attachmentId);
    return Services.post(UPLOAD_DELETE_URL, body);
  }

  getAttachmentCreative(idAttachment) {
    return Services.get(`${GET_ATTACHMENT_CREATIVE_URL}?attachmentId=${idAttachment}`);
  }

  getHistoryCreativeAssistant(body = { category: '', routeName: '' }) {
    return Services.post(`${CREATIVE_ASSISTANT_URL}/history`, body);
  }

  genAnswerCreativeAssistant(body) {
    return Services.post(CREATIVE_ASSISTANT_URL, body);
  }

  updateMultipleCreative({ creatives }) {
    return Services.post(`${CREATIVE_URL}/v2?action=update`, creatives);
  }

  exportCreative(
    body = {
      message: '',
      title: '',
      offset: 0,
      limit: 50,
      sortBy: '',
      sortDirection: '',
    }
  ) {
    return Services.post(`${CREATIVE_URL}`, {
      action: 'exportCSV',
      ...body,
    });
  }

  testPromptWS() {
    return Services.post()
  }
}

export default new CreativeServices();
